import { NgModule } from '@angular/core';
import { TextBoxDirective } from './textbox/textbox.directive';
import { TextBoxContainerComponent } from './textbox/textbox-container.component';
import { CommonModule } from '@angular/common';
/**
 * Represents the [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html)
 * definition for the TextBox directive.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the TextBox module
 * import { TextBoxModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, TextBoxModule], // import TextBox module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
var TextBoxModule = (function () {
    function TextBoxModule() {
    }
    return TextBoxModule;
}());
export { TextBoxModule };
TextBoxModule.decorators = [
    { type: NgModule, args: [{
                declarations: [TextBoxDirective, TextBoxContainerComponent],
                exports: [TextBoxDirective, TextBoxContainerComponent],
                imports: [CommonModule]
            },] },
];
/** @nocollapse */
TextBoxModule.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-inputs/dist/es/textbox.module.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/textbox.module.js
// module chunks = 3